export default __webpack_public_path__ + "static/media/187.af3a21a6.gif";